/**
 * The onboarding answers handoff.
 *
 * Written for the *authenticated* app to read after signup. No reader exists
 * in the Ember `ui` today, so the blob is emitted with its historical key set
 * (including the always-empty legacy fields) until the handoff is retired
 * outright rather than risk a reader that rejects a changed shape.
 *
 * With the `signup_skip_onboarding_questions` flag on, `messagingUseCases`
 * and `v2MessageChannels` are always empty arrays too.
 */
const WELCOME_DIALOG_COMPLETED_KEY = 'cio-welcome-dialog-completed';
const WELCOME_DIALOG_ANSWERS_KEY = 'cio-welcome-dialog-answers';

// Drafts written by the old signup flow; cleared so a stale draft never leaks
// into a future flow change.
const LEGACY_SIGNUP_FLOW_DRAFT_KEY = 'cio-signup-flow-draft-v2';

export type WelcomeDialogAnswers = {
  messagingUseCases: string[];
  v2MessageChannels: string[];
  v2Role: string | null;
};

export function saveWelcomeDialogAnswers(answers: WelcomeDialogAnswers): void {
  try {
    localStorage.setItem(
      WELCOME_DIALOG_ANSWERS_KEY,
      JSON.stringify({
        messagingUseCases: answers.messagingUseCases,
        selectedChannels: [],
        emailVolumeSelection: null,
        v2MessageChannels: answers.v2MessageChannels,
        v2Role: answers.v2Role,
        selectedPlan: null,
        completedAt: new Date().toISOString(),
      }),
    );
    localStorage.setItem(WELCOME_DIALOG_COMPLETED_KEY, 'true');
    clearStoredSignupDraft();
  } catch {
    // Storage unavailable — the app falls back to asking in the welcome dialog.
  }
}

export function clearStoredSignupDraft(): void {
  try {
    localStorage.removeItem(LEGACY_SIGNUP_FLOW_DRAFT_KEY);
  } catch {
    // Storage unavailable — nothing persisted to clear.
  }
}
